const createDOMPurify = require('dompurify');
const DOMPurify = createDOMPurify(window);
const sanitizer = DOMPurify.sanitize;

export default sanitizer;